export default __webpack_public_path__ + "static/media/wallpaper_bg4.8ccfe672.jpg";